import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/popups/mobile-app/popup-mobile-app.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/popups/pwa/pwa.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/merchant/card/merchant-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product/categories/categories-navigation/categories-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product/categories/categories-section/categories/categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product/categories/categories-section/promotions/promotions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product/categories/categories-section/weekly-top/weekly-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shopping-cart/shopping-cart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisibleCategoriesProvider"] */ "/app/src/context/product/category-product-context.tsx");
